/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermissionTypeViewModel } from '../../models/permission-type-view-model';

export interface GetPermissionTypes$Params {
}

export function GetPermissionTypes(http: HttpClient, rootUrl: string, params?: GetPermissionTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PermissionTypeViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPermissionTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PermissionTypeViewModel>>;
    })
  );
}

GetPermissionTypes.PATH = '/api/Permissions/GetPermissionTypes';
